import React, { useEffect, useState } from 'react';
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';

const SocialShareButtons = ({ title, onClick }) => {
    const [shareUrl, setShareUrl] = useState('');

    useEffect(() => {
        setShareUrl(window.location.href);
    }, []);

    const shareTitle = title || 'Ah Nyar Institute';

    return (
        <div style={{ display: 'flex', gap: '10px' }}>
            {/* Facebook */}
            <FacebookShareButton
                url={shareUrl}
                quote={shareTitle}
                hashtag="#AhNyarInstitute"
                className="social-share-button"
            >
                <div
                    onClick={onClick}
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#1877F2',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <FaFacebook size={20} color="#fff" />
                </div>
            </FacebookShareButton>

            {/* Twitter */}
            <TwitterShareButton
                url={shareUrl}
                title={shareTitle}
                hashtags={["AhNyarInstitute"]}
                className="social-share-button"
            >
                <div
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#1DA1F2',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <FaTwitter size={20} color="#fff" />
                </div>
            </TwitterShareButton>

            {/* LinkedIn */}
            <LinkedinShareButton
                url={shareUrl}
                title={shareTitle}
                className="social-share-button"
            >
                <div
                    onClick={onClick}
                    style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#0077B5',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <FaLinkedin size={20} color="#fff" />
                </div>
            </LinkedinShareButton>
        </div>
    );
};

export default SocialShareButtons;
